import { gql } from '@apollo/client';

export const ManualEventActionFragment = gql`
  fragment ManualEventActionFragment on ImportManualEventMatchStage {
    projectId
    __typename
  }
`;
